import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {GeocoderService} from '../../../../services/geocoder/geocoder.service';
import * as uuidv4 from 'uuid/v4';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ApiService} from "../../../../services/api";
import {UserContext} from "../../../../services/user-context";

@Component({
  selector: 'app-location-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'location-dialog.template.html',
  styles: [
    "app-location-dialog mat-dialog-container {padding:0;}",
    "app-location-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-location-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ],
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})

export class LocationDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    address: '',
    name: '',
    external_id: ''
  };
  public location: any;
  loading = false;

  constructor(private formBuilder: FormBuilder,
              private geocoder: GeocoderService,
              private snackBar: MatSnackBar,
              private userContext: UserContext,
              public dialogRef: MatDialogRef<LocationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    if ( data ) {
      this.location = Object.assign({}, data);
    } else {
      this.location = {id: uuidv4()};
    }
  }

  public ngOnInit(): void {
    this.buildForm();
    this.form.controls.address.valueChanges.subscribe(
      () => {
        delete this.location.latlng;
      }
    );

  }

  public buildForm() {
    this.form = this.formBuilder.group({

      address: new FormControl( this.location ? this.location.address : '', [
        Validators.required,
      ]),
      external_id: new FormControl( this.location ? this.location.external_id : '', [
      ]),
      name: new FormControl(this.location ? this.location.name : '', [
        Validators.required,
        Validators.minLength(3)
      ])
    });
  }

  public save() {
    this.dialogRef.close(Object.assign(this.location, this.form.value));
  }

  public validate() {
    this.location['name'] = this.form.value.name;
    this.loading = true;
    this.geocoder.geocode(this.form.value.address , (err, result) => {
      this.loading = false;
      if (err) {
        this.snackBar.open('Could not find address.', null, {
          duration: 2000
        });
      } else {
        if ( result.status === 'OK' ) {
          if ( result.results && result.results.length > 0 ) {
            const locationAddress = result.results[0];
            const geometry = locationAddress.geometry;
            this.location['latlng'] = [geometry.location.lat, geometry.location.lng];
            locationAddress.address_components.forEach( (c) => {
              if (c.types.includes('locality') ) {
                this.location['city'] = c.long_name;
              } else if (c.types.includes('administrative_area_level_1')) {
                this.location['region'] = c.short_name;
              } else if (c.types.includes('street_number')) {
                this.location['street_number'] = c.long_name;
              } else if (c.types.includes('subpremise')) {
                this.location['subpremise'] = c.short_name;
              } else if (c.types.includes('floor')) {
                this.location['floor'] = c.short_name;
              } else if (c.types.includes('room')) {
                this.location['room'] = c.short_name;
              } else if (c.types.includes('route')) {
                this.location['route'] = c.short_name;
              } else if (c.types.includes('postal_code')) {
                this.location['postal'] = c.long_name;
              } else if (c.types.includes('country')) {
                this.location['country'] = c.short_name;
              }
            });
            this.location['address'] = `${this.location['street_number']} ${this.location['route']}\n` +
              `${this.location['city']}, ${this.location['region']} ${this.location['postal']}`;

          }
        } else {
          this.snackBar.open('Location not found. Check address.', null, {
            duration: 2000
          });
        }
      }
    });
  }

  public cancel() {
    this.dialogRef.close();
  }

}
